const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');

class TikTokShopFeedChannel extends ChannelDefinition {
	id = 'tiktok-shop-feed';
	title = 'TikTok Shop Feed';
	description = 'Reach new customers by showcasing your products on TikTok Shop.';
	category = Categories.SOCIAL_COMMERCE;
	iconUrl = 'https://go.near.st/hubfs/channels/tiktok.svg';
	tag = 'Beta';
	comingSoon = true;

	worksWith = ['storefront'];

	get pricing() {
		return 'Contact support to find out more';
	}

	longDescription = `
## Overview
Connect your product inventory to TikTok Shop and make your products discoverable to millions of TikTok users. Showcase your in-store products directly on one of the fastest-growing social commerce platforms.

## How it works
NearSt generates a product feed from your live inventory that can be used to power your TikTok Shop catalogue. Contact our support team to get set up.

## Requirements
- An active NearSt inventory connection
- A TikTok for Business account

Please check the catalogue setup instructions provided by TikTok for up-to-date information on getting your products live using this feed.
	`;
}

module.exports = TikTokShopFeedChannel;
